export const MotorbikeMarkerSvg = () => {
  return (
    <svg
      width="66"
      height="72"
      viewBox="0 0 66 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_8196_85925)">
        <circle cx="33" cy="31" r="28" fill="#0157E7" />
        <g filter="url(#filter1_d_8196_85925)">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M37.166 56.668C49.545 54.6744 59 43.9414 59 31C59 16.6406 47.3594 5 33 5C18.6406 5 7 16.6406 7 31C7 43.9414 16.455 54.6744 28.834 56.668L33 65L37.166 56.668Z"
            fill="white"
          />
        </g>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M22 31C19.7909 31 18 32.7909 18 35C18 37.2091 19.7909 39 22 39C24.2091 39 26 37.2091 26 35C26 32.7909 24.2091 31 22 31ZM17 35C17 32.2386 19.2386 30 22 30C24.7614 30 27 32.2386 27 35C27 37.7614 24.7614 40 22 40C19.2386 40 17 37.7614 17 35Z"
          fill="#0C1822"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M44 31C41.7909 31 40 32.7909 40 35C40 37.2091 41.7909 39 44 39C46.2091 39 48 37.2091 48 35C48 32.7909 46.2091 31 44 31ZM39 35C39 32.2386 41.2386 30 44 30C46.7614 30 49 32.2386 49 35C49 37.7614 46.7614 40 44 40C41.2386 40 39 37.7614 39 35Z"
          fill="#0C1822"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M36.0181 21.3665C36.0781 21.1499 36.2753 21 36.5 21H41C41.085 21 41.1685 21.0217 41.2428 21.0629C42.0149 21.4918 43.1711 22.2363 44.1419 23.0863C44.627 23.511 45.0804 23.9748 45.4163 24.4508C45.7467 24.9189 46 25.4505 46 26C46 27.0123 45.8794 27.7697 45.541 28.2773C45.1615 28.8467 44.5877 29 44 29C43.9537 29 43.9005 28.9992 43.8409 28.9982C43.2138 28.9885 41.8872 28.9678 40.6523 29.791C39.3381 30.6672 38 32.6019 38 37V37.5C38 37.7761 37.7761 38 37.5 38H28.5C28.2239 38 28 37.7761 28 37.5V35.5C28 35.47 28.0027 35.4401 28.0081 35.4106C28.1599 34.5753 28.1372 33.2307 27.569 31.9676C27.0109 30.727 25.918 29.5414 23.8684 28.9824C23.8309 28.9721 23.7947 28.9576 23.7606 28.9389L18.2606 25.9389C18.0999 25.8513 18 25.683 18 25.5V24.5C18 24.2239 18.2239 24 18.5 24H23.5C23.7294 24 23.9294 24.1561 23.9851 24.3787C24.0233 24.5316 24.2477 24.9344 24.9483 25.3091C25.6368 25.6773 26.7589 26 28.5 26H29.061C29.144 25.6487 29.3188 25.2594 29.6284 24.9155C30.1112 24.379 30.879 24 32 24H36C37.1635 24 38.1468 24.5794 38.8566 25.0956C39.0942 25.2685 39.3221 25.4506 39.5121 25.6026C39.6011 25.6738 39.6819 25.7383 39.7514 25.7921C39.8696 25.8837 39.9564 25.9455 40.0205 25.9833C40.0328 25.9906 40.0427 25.996 40.0505 26H41V25.6695C40.0592 24.468 38.6427 23.3687 36.2428 21.9287C36.05 21.8131 35.9582 21.5831 36.0181 21.3665ZM38.2408 22C39.9169 23.1036 41.066 24.0879 41.9 25.2C41.9649 25.2865 42 25.3918 42 25.5V26.5C42 26.7761 41.7761 27 41.5 27H40C39.7948 27 39.6173 26.9065 39.5127 26.8448C39.3913 26.7732 39.2632 26.6788 39.1392 26.5829C39.0468 26.5113 38.9544 26.4373 38.8589 26.3609C38.6795 26.2173 38.4894 26.0651 38.2684 25.9044C37.6032 25.4206 36.8365 25 36 25H32C31.121 25 30.6388 25.2877 30.3716 25.5845C30.0901 25.8973 30 26.273 30 26.5C30 26.7761 29.7761 27 29.5 27H28.5C26.6411 27 25.3466 26.6561 24.4767 26.1909C23.8235 25.8416 23.3919 25.412 23.1665 25H19V25.2032L24.1888 28.0334C26.5035 28.6814 27.8113 30.0686 28.481 31.5574C29.1361 33.0137 29.1724 34.5444 29 35.5439V37H37C37 32.3981 38.4119 30.0828 40.0977 28.959C41.6076 27.9524 43.2351 27.9853 43.8559 27.9979C43.9126 27.999 43.9609 28 44 28C44.4123 28 44.5885 27.9033 44.709 27.7227C44.8706 27.4803 45 26.9877 45 26C45 25.7495 44.8783 25.4227 44.5993 25.0273C44.3258 24.6398 43.9355 24.2348 43.4831 23.8387C42.6242 23.0866 41.5941 22.4123 40.8691 22H38.2408Z"
          fill="#0C1822"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M27.6857 31.9644L22.5963 34.0001H22.5C22.2239 34.0001 22 34.224 22 34.5001C22 34.7763 22.2239 35.0001 22.5 35.0001H28.5V36.0001H22.5C21.6716 36.0001 21 35.3286 21 34.5001C21 33.7071 21.6153 33.0579 22.3946 33.0038L27.3143 31.0359L27.6857 31.9644Z"
          fill="#0C1822"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M41.2765 29.0529C41.5235 28.9294 41.8238 29.0295 41.9473 29.2765L44.9473 35.2765C45.0708 35.5235 44.9707 35.8238 44.7237 35.9473C44.4767 36.0708 44.1764 35.9707 44.0529 35.7237L41.0529 29.7237C40.9294 29.4767 41.0295 29.1764 41.2765 29.0529Z"
          fill="#0C1822"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_8196_85925"
          x="-4"
          y="-2"
          width="74"
          height="74"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="1"
            operator="dilate"
            in="SourceAlpha"
            result="effect1_dropShadow_8196_85925"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0470588 0 0 0 0 0.0941176 0 0 0 0 0.133333 0 0 0 0.05 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8196_85925"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2.5" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.0470588 0 0 0 0 0.0941176 0 0 0 0 0.133333 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_8196_85925"
            result="effect2_dropShadow_8196_85925"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_8196_85925"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_d_8196_85925"
          x="5"
          y="4"
          width="56"
          height="64"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_8196_85925"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_8196_85925"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
};
